/**
 * Constants shared between environment-related components
 */

/** Local storage key for environment color preferences */
export const ENVIRONMENT_COLOR_STORAGE_KEY = "frends.environment.color";